<template>
    <div class="account" style="margin-bottom: 30px; padding-top: 30px;">
        <div class="home-wrapper-container">
            <template v-if="manager">
                <div class="header-home setting" style="line-height: 1;">
                    Manager access
                </div>
                <div class="flex-height-max flex-row" style="margin-bottom: 60px;">
                    <div class="content profile-content">
                        <div class="mb-3" style="font-size: 14px; line-height: 1.5;">
                            Manager users can view, edit, and manage your PPC Shield account including the subscription plan.
                        </div>

                        <custom-input
                            name="account_name"
                            type="text"
                            :disabled="true"
                            v-model="manager.account_name"
                            label="Manager account name"
                        ></custom-input>

                        <custom-input
                            name="username"
                            type="text"
                            :disabled="true"
                            v-model="manager.email"
                            label="Email"
                        ></custom-input>

                        <custom-input
                            name="linked_on"
                            type="text"
                            :disabled="true"
                            v-model="manager.linked_on"
                            label="Linked on"
                        ></custom-input>

                        <button class="btn btn-primary mt-3 w-100" v-on:click="show('remove-manager-access-modal')">REMOVE ACCESS</button>
                    </div>
                    <div class="content-right-side">
                        <div class="right-img"></div>
                    </div>
                </div>
            </template>

            <template v-else-if="link_request">
                <div class="header-home setting" style="line-height: 1;">
                    Pending manager link request
                </div>
                <div class="flex-height-max flex-row" style="margin-bottom: 60px;">
                    <div class="content profile-content">
                        <div class="mb-3" style="font-size: 14px; line-height: 1.5;">
                            Manager users can view, edit, and manage your PPC Shield account, but not subscription details or billing information.
                        </div>

                        <custom-input
                            name="account_name"
                            type="text"
                            :disabled="true"
                            v-model="link_request.account_name"
                            label="Manager account name"
                        ></custom-input>

                        <custom-input
                            name="username"
                            type="text"
                            :disabled="true"
                            v-model="link_request.email"
                            label="Email"
                        ></custom-input>

                        <button class="btn btn-primary mt-3 w-100" v-on:click="acceptLinkRequestAction()">ACCEPT LINK REQUEST</button>
                        <button class="btn btn-danger mt-3 w-100" v-on:click="declineLinkRequestAction()">DECLINE</button>
                    </div>
                    <div class="content-right-side">
                        <div class="right-img"></div>
                    </div>
                </div>
            </template>

            <div class="header-home setting" style="line-height: 1;">
                Tell us about yourself and your business
            </div>
            <div class="flex-height-max flex-row" style="margin-bottom: 60px;">
                <div class="content profile-content">
                    <div class="mb-3" style="font-size: 14px; line-height: 1.5;">
                        This information will help us deliver a better user experience and personalized service.
                    </div>
                    <custom-input
                        name="user_name"
                        type="text"
                        v-model="user_name"
                        label="Name"
                        :errors="errors"
                    ></custom-input>

<!--                    <label for="job_title" class="main-form__label mt-1 w-100">
                        <input id="job_title"
                               type="text"
                               v-model="job_title"
                               class="main-form__field"
                               name="job_title"
                               autocomplete="off">
                        <span class="main-form__field__title">
                            Job title
                        </span>
                        <span v-if="errors['job_title']" class="invalid-feedback">
                            <template><strong>{{ errors['job_title'][0] }}</strong></template>
                        </span>
                    </label>-->
                    <custom-input
                        name="phone_number"
                        type="text"
                        v-model="phone"
                        label="Phone number (including the country prefix)"
                        :errors="errors"
                        :additional_handling="phone_mask"
                    ></custom-input>


                    <custom-input
                        name="who_do_you_manage_ads_for"
                        type="select"
                        v-model="selected_profile_type"
                        value_name="name"
                        label="Who do you manage ads for?"
                        :select_options="profile_types"
                        :errors="errors"
                    ></custom-input>

                    <custom-input
                        name="your_industry"
                        type="select"
                        v-model="selected_industry_type"
                        value_name="name"
                        label="Your industry"
                        :select_options="industry_types"
                        :errors="errors"
                    ></custom-input>

                    <custom-input
                        name="company_name"
                        type="text"
                        v-model="company_name"
                        label="Company name / Website"
                        :errors="errors"
                    ></custom-input>

                    <custom-input
                        name="company_size"
                        type="select"
                        v-model="selected_company_size_type"
                        value_name="name"
                        label="Company size (number of employees)"
                        :select_options="company_size_types"
                        :errors="errors"
                    ></custom-input>

                    <button class="btn btn-primary mt-3 w-100" :disabled="has_changed_data_profile" v-on:click="saveProfile">SAVE</button>
                </div>
                <div class="content-right-side">
                    <img class="right-img" src="/images/undraw_Personal_site_re_c4bp.svg" alt="setting">
                </div>
            </div>
        </div>
        <div class="home-wrapper-container">
            <div class="header-home setting" style="line-height: 1;">
                Time preferences
            </div>
            <div class="flex-height-max flex-row" style="margin-bottom: 60px;">
                <div class="content profile-content">
                    <custom-input
                        name="date_format"
                        type="select"
                        v-model="selectedDateTimeFormats.date_format"
                        value_name="label"
                        label="Date format"
                        :select_options="loadedDateTimeFormats.date_format_list"
                        :errors="errors"
                    ></custom-input>

                    <custom-input
                        name="time_format"
                        type="select"
                        v-model="selectedDateTimeFormats.time_format"
                        value_name="label"
                        label="Time format"
                        :select_options="loadedDateTimeFormats.time_format_list"
                        :errors="errors"
                    ></custom-input>
                    <custom-input
                        name="timezone"
                        type="select"
                        v-model="selected_timezone"
                        value_name="label"
                        label="Time zone"
                        :select_options="timezone_list"
                        :errors="errors"
                        hint="*Please note: Time zone differences between your Google Ads and PPC Shield accounts might result in minor differences in statistics"
                    ></custom-input>

                    <button class="btn btn-primary mt-3 w-100" :disabled="has_changed_data_timezone" v-on:click="saveTimePreferences">SAVE</button>
                </div>
                <div class="content-right-side">
                    <div class="right-img"></div>
                </div>
            </div>
        </div>
        <div class="home-wrapper-container">
            <div class="header-home" style="line-height: 1; margin-top: 60px;">
                Password
            </div>
            <div class="flex-height-max flex-row" style="margin-bottom: 60px;">
                <div v-if="is_google" style="font-size: 14px; line-height: 1.5;">
                    You're logged in with your Google account.
                </div>
                <div v-else style="font-size: 14px; line-height: 1.5;">
                    You can change your password by clicking <a href="/" @click.prevent="onOpenChangePassword" style="text-decoration: underline;">here</a>
                </div>
            </div>
        </div>
       <div class="home-wrapper-container" v-if="false">     <!-- Has been hidden due Lev request-->
            <div class="header-home setting" style="line-height: 1;">
                Cancel your PPC Shield account
            </div>
            <div class="flex-height-max flex-row">
                <div class="content profile-content" style="width: 500px; flex-flow: nowrap; flex-direction: column;">
                    <div class="mb-3" style="font-size: 14px; line-height: 1.5;">
                        Before you go, please leave some quick feedback to help improve our service.
                    </div>
                    <form>
                        <span class="ip-form__field-title">
                            Reason for leaving:
                        </span>
                        <div class="radio-buttons ">
                            <div class="ml-2">
                                <input type="radio" id="reason1" name="reason" :value="1"
                                       v-model="reason">
                                <label for="reason1">I’m not using your product anymore</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason2" name="reason" :value="2"
                                       v-model="reason">
                                <label for="reason2">The pricing is too high</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason3" name="reason" :value="3"
                                       v-model="reason">
                                <label for="reason3">I’m switching to a different product/solution</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason4" name="reason" :value="4"
                                       v-model="reason">
                                <label for="reason4">It doesn't meet my needs</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason5" name="reason" :value="5"
                                       v-model="reason">
                                <label for="reason5">Too few features</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason6" name="reason" :value="6"
                                       v-model="reason">
                                <label for="reason6">Temporary use case</label>
                            </div>
                            <div class="ml-2">
                                <input type="radio" id="reason7" name="reason" :value="7"
                                       v-model="reason">
                                <label for="reason7">Other</label>
                            </div>
                            <div class="ml-2" v-if="reason === 7">
                        <textarea name="reason_other" rows="5" cols="50" placeholder="Please specify"
                                  v-model="otherReason">
                        </textarea>
                            </div>
                        </div>
                    </form>


                    <div v-if="error_text" style="color: #ff0000; margin-bottom: 13px">
                        {{ error_text }}
                    </div>
                    <div class="btn btn-danger mt-3 w-100" @click="validateReason">Close account</div>
<!--                    <div class="btn btn-danger mt-3 w-100" @click="show('cancel-unavailable-modal')">Close account</div>-->
                </div>
                <div class="content-right-side">
                    <div class="right-img" style="width: unset;"></div>
                </div>
            </div>
        </div>

        <modal :height="'auto'" :width="'400px'" name="cancel-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Delete account
                </div>

                <div class="body">
                    Are you sure you want to delete your account temporarily? This means all data and settings will
                    be lost. The linked Google Ads accounts will no longer be protected by PPC Shield.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hide('cancel-modal')">DISAGREE
                    </button>
                    <button class="btn" @click="cancelAccount">AGREE</button>
                </div>
            </div>
        </modal>


        <modal :height="'auto'" :width="'400px'" name="cancel-result-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    {{cancelResultTitle}}
                </div>

                <div class="body">
                    {{cancelResult}}
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="logout()">
                        CLOSE
                    </button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="cancel-unavailable-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Sorry!
                </div>
                <div class="body">
                    This service is temporary unavailable, please try again later. You can cancel your subscription by accessing the Subscription page in your profile menu, clicking the Manage button, and then clicking Cancel plan.
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn" @click="hide('cancel-unavailable-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'382px'" name="change-password-modal">
            <div class="informative-modal flex flex-col">
                <div class="header" style="padding-bottom: 30px;">
                    Change your password
                </div>
                <div class="body">
                    <custom-input
                        name="password"
                        type="password"
                        v-model="changePassword.password"
                        label="New password"
                        autocomplete="new-password"
                        hint="Use 8 or more characters with a mix of letters and numbers."
                        :errors="errors"
                        style="margin-bottom: 26px;"
                    ></custom-input>

                    <custom-input
                        name="password_confirmation"
                        type="password"
                        v-model="changePassword.password_confirmation"
                        label="Confirm new password"
                        autocomplete="new-password"
                        hint="Use 8 or more characters with a mix of letters and numbers."
                        :errors="errors"
                    ></custom-input>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn mr-2" @click="hide('change-password-modal')">Close</button>
                    <button class="btn btn-primary" @click="onChangePassword()">CHANGE PASSWORD</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'382px'" name="success-change-password-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">

                </div>
                <div class="body">
                    You have successfully changed your password
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn mr-2" @click="hide('success-change-password-modal')">Close</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="remove-manager-access-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Remove manager
                </div>
                <div class="body">
                    Are you sure you want to remove this manager access?
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-gray mr-2" @click="hide('remove-manager-access-modal')">Cancel</button>
                    <button class="btn btn-danger default" @click="removeManagerAccessAction()">Yes, remove it</button>
                </div>
            </div>
        </modal>

        <modal :height="'auto'" :width="'400px'" name="accept-error-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Error
                </div>
                <div class="body">
                    Your account is already linked to <b>{{error_accept_link_email}}</b>
                </div>
                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-gray" @click="reloadPage()">Cancel</button>
                </div>
            </div>
        </modal>
    </div>
</template>
<style lang="scss">
    .cancelling {
        max-width: 536px;

        .ml-2 {
            margin-left: 0 !important;
        }

        .radio-buttons {
            padding-top: 4px;
        }

        textarea {
            width: 100%;
            margin-bottom: 6px;
        }
    }
    .account{
      .main-form__field{
        color: #636b6f;
      }

      .header-home{
        font-size: 22px;
        font-weight: 400;
        color: #495057;
      }
    }
</style>
<script>
    export default {
        name: 'account-settings',
        props: ["link_request_raw", "manager_raw", 'is_google'],
        data: function () {
            return {
                user_name: '',
                user_email: '',
                currentStep: 1,
                industry_types: [],
                selected_industry_type: {id: '', name: ''},
                profile_types: [],
                selected_profile_type: {id: '', name: ''},
                company_size_types: [],
                selected_company_size_type: {id: '', name: ''},
                job_title: '',
                phone: '',
                company_name: '',

                errors: {name: ''},
                loaded_data: {},


                timezone_list: [],
                selected_timezone: {label: '', tzCode: ''},
                loaded_timezone: '',


                isLoading: true,
                isOther: false,
                reason: '',
                otherReason: '',
                tableData: null,
                accounts: [],
                error_text: '',
                cancelResult: '',
                cancelResultTitle: '',
                addData: {
                    account_id: null,
                    address: "",
                },
                filter: {
                    query: ''
                },

                link_request: JSON.parse(this.link_request_raw),
                manager: JSON.parse(this.manager_raw),
                error_accept_link_email: '',

                changePassword: {password: '', password_confirmation: ''},
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

                selectedDateTimeFormats: {
                    'date_format': {},
                    'time_format': {},
                },
                loadedDateTimeFormats: {
                    'date_format': '',
                    'time_format': '',
                    'date_format_list': [],
                    'time_format_list': [],
                },
            }
        },
        computed:{
            has_changed_data_profile(){
                if(this.user_name !== this.loaded_data.user_name) return false;
                if(this.job_title !== this.loaded_data.profile.job_title) return false;
                if(this.phone !== this.loaded_data.profile.phone) return false;
                if(this.company_name !== this.loaded_data.profile.company_name) return false;
                if(this.selected_profile_type.id !== this.loaded_data.profile.type_id) return false;
                if(this.selected_company_size_type.id !== this.loaded_data.profile.company_size_id) return false;
                if(this.selected_industry_type.id !== this.loaded_data.profile.industry_type_id) return false;

                return true;
            },
            has_changed_data_timezone(){
                if(this.selected_timezone.tzCode !== this.loaded_timezone) return false;
                if(this.selectedDateTimeFormats.date_format !== this.loadedDateTimeFormats.date_format) return false;
                if(this.selectedDateTimeFormats.time_format !== this.loadedDateTimeFormats.time_format) return false;

                return true;
            }
        },
        methods: {
            onOpenChangePassword(){
                this.changePassword = {password: '', password_confirmation: ''};
                this.errors = {name: ''};
                this.show('change-password-modal');
            },
            onChangePassword() {
                axios.post('accountSettings/changePassword',{
                    ...this.changePassword,
                    token: this.csrf
                })
                    .then(info => {
                        this.errors = {name: ''};
                        this.hide('change-password-modal');
                        this.show('success-change-password-modal');
                    })
                    .catch(info => {
                        this.errors = info.response.data?.errors;
                    });
            },
            reloadPage(){
                this.hide('accept-error-modal');
                location.reload();
            },
            declineLinkRequestAction(){
                axios.post('accountSettings/declineManagerLinkRequest',{
                    link_request_id: this.link_request.link_request_id
                })
                    .then(info => {
                        this.link_request = null;
                        if(info.data?.link_request){
                            this.link_request = info.data.link_request;
                        }
                    })
                    .catch(err => {
                        console.log('err', err);
                    });
            },
            acceptLinkRequestAction(){
                axios.post('accountSettings/acceptManagerLinkRequest',{
                    link_request_id: this.link_request.link_request_id
                })
                    .then(info => {
                        if(info.data.error && info.data.error === 'managed'){
                            this.error_accept_link_email = info.data.email;
                            this.show('accept-error-modal');
                        }
                        else{
                            this.manager = {...this.link_request};
                            this.link_request = null;
                            this.inputChanged();
                        }
                    })
                    .catch(err => {
                        console.log('err', err);
                    });
            },
            removeManagerAccessAction(){
                axios.post('accountSettings/removeManagerAccess')
                    .then(info => {
                        this.manager = null;
                        this.link_request = null;
                        if(info.data?.link_request){
                            this.link_request = info.data.link_request;
                        }
                        this.hide('remove-manager-access-modal');
                    })
                    .catch(err => {
                        console.log('err', err);
                        this.hide('remove-manager-access-modal');
                    });
            },
            phone_mask(value){
                if(value === '' || value === '+') return '';
                else if(value[0] !== '+') return '+' + value;
                else return value;
            },
            getProfileData() {
                axios.post('accountSettings/getProfile')
                    .then(info => {
                        const {data} = info;
                        this.loaded_data = data;
                        this.profile_types = data.profile_types;
                        this.industry_types = data.industry_types;
                        this.company_size_types = data.company_size_types;
                        this.job_title = data.profile.job_title;
                        this.phone = data.profile.phone;
                        this.company_name = data.profile.company_name;
                        this.user_email = data.user_email;
                        this.user_name = data.user_name;
                        if(data.profile.type_id) this.selected_profile_type = this.profile_types.filter((item) => item.id === data.profile.type_id)[0];
                        else this.loaded_data.profile.type_id = this.selected_profile_type.id;
                        if(data.profile.company_size_id) this.selected_company_size_type = this.company_size_types.filter((item) => item.id === data.profile.company_size_id)[0];
                        else this.selected_company_size_type.id = this.loaded_data.profile.company_size_id;
                        if(data.profile.industry_type_id) this.selected_industry_type = this.industry_types.filter((item) => item.id === data.profile.industry_type_id)[0];
                        else this.loaded_data.profile.industry_type_id = this.selected_industry_type.id;

                        this.loadedDateTimeFormats = data.time_preferences;
                        this.loadedDateTimeFormats.date_format = this.selectedDateTimeFormats.date_format = this.loadedDateTimeFormats.date_format_list.find((item) => item.label === this.loadedDateTimeFormats.date_format);
                        this.loadedDateTimeFormats.time_format = this.selectedDateTimeFormats.time_format = this.loadedDateTimeFormats.time_format_list.find((item) => item.label === this.loadedDateTimeFormats.time_format);

                        this.inputChanged();
                    })
                    .catch(err => console.log('err', err));
            },
            getTimezones() {
                axios.get('accountSettings/getTimezones')
                    .then(info => {
                        const {data} = info;
                        this.timezone_list = data.timezone_list;
                        this.selected_timezone = data.timezone_list.filter((item) => item.tzCode === data.timezone)[0];
                        this.loaded_timezone = data.timezone;
                        this.inputChanged();
                    })
                    .catch(err => console.log('err', err));
            },
            saveTimePreferences(){
                axios.post('/accountSettings/saveTimePreferences', {
                    'timezone': this.selected_timezone.tzCode,
                    'date_format': this.selectedDateTimeFormats.date_format.value,
                    'time_format': this.selectedDateTimeFormats.time_format.value,
                })
                    .then(info => {
                        this.loaded_timezone = this.selected_timezone.tzCode;
                        this.loadedDateTimeFormats.date_format = this.selectedDateTimeFormats.date_format;
                        this.loadedDateTimeFormats.time_format = this.selectedDateTimeFormats.time_format;
                    })
                    .catch(info => {
                        this.errors = info.response.data?.errors;
                    });
            },
            saveProfile(){
                axios.post('/setup/profileSave', {
                    'user_name': this.user_name,
                    'job_title': this.job_title,
                    'phone_number': this.phone,
                    'who_do_you_manage_ads_for': this.selected_profile_type.id,
                    'your_industry': this.selected_industry_type.id,
                    'company_name': this.company_name,
                    'company_size': this.selected_company_size_type.id,
                })
                    .then(info => {
                        this.loaded_data.user_name = this.user_name;
                        this.loaded_data.profile.job_title = this.job_title;
                        this.loaded_data.profile.phone = this.phone;
                        this.loaded_data.profile.company_name = this.company_name;
                        this.loaded_data.profile.type_id = this.selected_profile_type.id;
                        this.loaded_data.profile.company_size_id = this.selected_company_size_type.id;
                        this.loaded_data.profile.industry_type_id = this.selected_industry_type.id;
                        this.errors = {name: ''};
                    })
                    .catch(info => {
                        this.errors = info.response.data?.errors;
                    });
            },
            inputChanged(){
                setTimeout(() => {$("input.main-form__field").each( function (){
                    if($( this ).val() !== ''){
                        $(this).siblings('.main-form__field__title').toggleClass('to-top', true);
                    }
                })}, 200);
            },
            showSelectDialog(input_id){
                $('#'+input_id).siblings('.select-options').toggleClass('show', true);
            },
            hideSelectDialog(event, input_id){
                event.stopPropagation();
                $('#'+input_id).siblings('.select-options').toggleClass('show', false);
            },
            setSelectDialogValue(input_id){
                $('#'+input_id).siblings('.main-form__field__title').toggleClass('to-top', true);
            },
            validateReason() {
                axios.post('/accountSettings/validateReason', {
                    'reason': this.reason,
                    'otherReason': this.otherReason
                })
                    .then(info => {
                        this.error_text = '';
                        this.show();
                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
                            this.error_text = Object.values(err.response.data.errors)[0][0];
                        }
                    });
            },
            cancelAccount() {
                this.hide('cancel-modal');
                this.show('cancel-result-modal');
                this.cancelResult = 'Your request to close your PPC Shield account has been received. When your account is deleted, you will be notified by email';
                this.cancelResultTitle = '';

                axios.post('/accountSettings/cancelAccount', {
                    'reason': this.reason,
                    'otherReason': this.otherReason
                })
                    .then(info => {

                    })
                    .catch(err => {
                        if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
                            this.$notify({
                                group: 'foo',
                                type: 'warn',
                                title: 'Error',
                                text: err.response.data.errors.google_ads_id[0]
                            });
                        }
                    });
            },
            show(modalWindow = 'cancel-modal') {
                this.$modal.show(modalWindow);
            },
            hide(modalWindow) {
                this.$modal.hide(modalWindow);
            },
            logout() {
                window.location = "/logout";
            }
        },
        mounted() {
            this.getProfileData();
            this.getTimezones();
        }
    }
</script>
